






























































import { Component, Mixins, PropSync } from 'vue-property-decorator';
import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { compass } from '@resclick/compass';
import { IEmailAccount } from '@resclick/data-access';

@Component
export default class TabEmail extends Mixins(ModalTabMixin) {
  @PropSync('id', { type: String }) idSync!: string;

  created() {
    this.form = this.$crsForm('companies', 'update', {
      emailAccount: {
        sender: '',
        email: '',
        password: '',
        provider: null as any,
        customProvider: {
          smtp: {
            host: '',
            port: 465,
            secure: true,
          },
        },
        confirmationEmails: [],
      },
    });

    this.$on('update-data', () => {
      this.getForm()
        .then((res) => res.data)
        .then((data) => {
          this.form = this.$crsForm('companies', 'update', data);
        });
    });
  }

  async getForm() {
    return compass
      .do('companies', 'findOne', {
        params: { companyId: this.idSync },
        populate: [{ path: 'emailAccount' }],
      })
      .then((res) => {
        if (res.data && res.data.emailAccount && (res.data?.emailAccount as IEmailAccount).customProvider) {
          (res.data.emailAccount as IEmailAccount).customProvider = {
            smtp: {
              host: '',
              port: 465,
              secure: true,
            },
          };
        }
        return res;
      });
  }
}
